import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroManualJournalRequestCard', {
    narration: 'Narration',
    date: 'Date',
    showOnCashBasisReports: 'Show journal on cash basis reports',
});
